import UserRepository from "./UserRepository";
import AthleteRepository from "./AthleteRepository.js";
import EventsRepository from "./EventsRepository.js";
import CollegeCoachRepository from "./CollegeCoachRepository.js";
import CollegeRepository from "./CollegeRepository.js";
import ClubCoachRepository from "./ClubCoachRepository.js";
import TaxonomyRepository from "./TaxonomyRepository.js";
import FooterRepository from "./FooterRepository.js";

const repositories = {
  users: UserRepository,
  coach: CollegeCoachRepository,
  college: CollegeRepository,
  athlete: AthleteRepository,
  events: EventsRepository,
  clubCoach: ClubCoachRepository,
  taxonomy: TaxonomyRepository,
  footer: FooterRepository
};

export const RepositoryFactory = {
  get: name => repositories[name]
};
